import React from "react";
import CartSection from "../../components/user/CartSection";
import Layout from "../../components/user/Layout"


const CartPage = () => {

  return (
    <>
      <Layout>
        <CartSection />
      </Layout>
    </>
  );
};

export default CartPage;
